import { IconSizes, LoadingIcon, type IconProps } from '@newcore/icons';
import { cn } from '../../utils/cn';

export interface SpinnerProps extends Omit<IconProps, 'size'> {
  size?: IconSizes;
}

export function Spinner({
  size = IconSizes.SM,
  className,
  ...props
}: SpinnerProps) {
  return (
    <LoadingIcon
      size={size}
      className={cn('animate-spin', className)}
      {...props}
    />
  );
}
